import { ChangeDetectionStrategy, Component, InputSignal, InputSignalWithTransform, booleanAttribute, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BlockDirective, ElemDirective } from '@rt-tools/core';

const BEM_BLOCK: string = 'sc-blog-article-card';

@Component({
    selector: 'sc-blog-article-card',
    templateUrl: './blog-article-card.component.html',
    styleUrl: './blog-article-card.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // angular
        RouterLink,

        // rt-tools
        BlockDirective,
        ElemDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class BlogArticleCardComponent {
    public readonly slug: InputSignal<string> = input.required<string>();
    /** Путь страницы статьи на сайте. */
    public readonly path: InputSignal<string> = input.required<string>();
    public readonly groupLabel: InputSignal<string> = input.required<string>();
    public readonly title: InputSignal<string> = input.required<string>();
    public readonly description: InputSignal<string> = input.required<string>();
    public readonly imageSrc: InputSignal<string | null> = input.required<string | null>();
    public readonly imageSrcset: InputSignal<string | null> = input<string | null>(null);
    public readonly topLevel: InputSignalWithTransform<boolean, unknown> = input<boolean, unknown>(false, { transform: booleanAttribute });
}
